import { render, staticRenderFns } from "./RegRoadentsList.vue?vue&type=template&id=6dcdbd58"
import script from "./RegRoadentsList.vue?vue&type=script&lang=js"
export * from "./RegRoadentsList.vue?vue&type=script&lang=js"
import style0 from "./RegRoadentsList.vue?vue&type=style&index=0&id=6dcdbd58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports